import type { StatusConfig } from "../../../shared/styles";

export const getInitials = (name: string): string => {
  if (!name) return '';
  const words = name.trim().split(/\s+/);
  if (words.length === 1) {
    return words[0].substring(0, 2).toUpperCase();
  }
  return (words[0][0] + words[1][0]).toUpperCase();
};

export const formatDate = (dateString: string, locale: string = 'fr-FR'): string => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric' });
};

export const getStatusConfig = (status: string): StatusConfig => {
  switch (status) {
    case 'active':
      return { bg: 'rgba(52, 211, 153, 0.1)', color: '#34d399', border: 'rgba(52, 211, 153, 0.2)' };
    case 'draft':
      return { bg: 'rgba(251, 191, 36, 0.1)', color: '#f59e0b', border: 'rgba(251, 191, 36, 0.2)' };
    case 'inactive':
      return { bg: 'rgba(156, 163, 175, 0.1)', color: '#6b7280', border: 'rgba(156, 163, 175, 0.2)' };
    case 'suspended':
      return { bg: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', border: 'rgba(239, 68, 68, 0.2)' };
    default:
      return { bg: 'rgba(156, 163, 175, 0.1)', color: '#6b7280', border: 'rgba(156, 163, 175, 0.2)' };
  }
};
